"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _input = _interopRequireDefault(require("../../../../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../../../../core/input-on-blur"));
var _row = _interopRequireDefault(require("../../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../../core/col"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("h5", null, "Do you want to print new cards for postal entries?");
var _ref2 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref3 = /*#__PURE__*/_react.default.createElement("h5", null, "Which divisions do you want to include?");
var _ref4 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref5 = /*#__PURE__*/_react.default.createElement("h5", null, "Restrict By Date:");
var _ref6 = /*#__PURE__*/_react.default.createElement(_col.default, {
  xs: 6
}, "Only include entries accepted after:");
var _ref7 = /*#__PURE__*/_react.default.createElement("p", null, "(Leave date blank for all entries)");
class ChooseEntries extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: this.props.includePostal,
      onChange: this.props.onTogglePostal,
      label: "Include Postal Entries"
    }), _ref2, _ref3, this.props.competitionDivisions.map(division => /*#__PURE__*/_react.default.createElement(_input.default, {
      key: division.id,
      type: "Checkbox",
      checked: this.props.selectedDivisions.includes(division.id),
      onChange: this.props.onToggleDivision.bind(this, division.id),
      label: division.description
    })), _ref4, _ref5, /*#__PURE__*/_react.default.createElement(_row.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Date",
      name: "dateRestriction",
      value: this.props.dateRestriction,
      onChange: this.props.setDateRestriction,
      required: false
    }))), _ref7);
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(ChooseEntries, "partialQueries", {
  CompetitionDivisions: {
    id: true,
    description: true
  }
});
var _default = exports.default = ChooseEntries;